module.exports = __webpack_public_path__ + "static/media/financiamiento.06015590.png";